var SearchWithResultsSpotController = (function () {
    function SearchWithResultsSpotController($scope, $timeout) {
        var _this = this;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$timeout(function () {
            _this.$scope.isComponentRendered = true;
        });
    }
    SearchWithResultsSpotController.$inject = [
        '$scope',
        '$timeout',
    ];
    return SearchWithResultsSpotController;
}());
export { SearchWithResultsSpotController };
